export enum Country {
  CZ = 'Czech Republic',
  SK = 'Slovakia',
  PL = 'Poland',
  HU = 'Hungary',
  RO = 'Romania'
}
